import { axios } from 'api'

type CheckoutParams = {
  discountCode?: string
  poNumber?: string
  paymentProfileId?: string
  cardNumber?: string
  expirationDate?: string
  cvv?: string
  firstName?: string
  lastName?: string
  address?: string
  city?: string
  state?: string
  zipCode?: string
}

type CheckoutResponse = { success: true } | { success: false; error: string }

type OrderLockStatusResponse =
  | { locked: true }
  | { locked: false; orderCompleted: boolean; message?: string }

export const checkout = async (
  params: CheckoutParams
): Promise<CheckoutResponse> => {
  try {
    const response = await axios.post('/orders/checkout', params)

    if (response.status === 201) {
      return { success: true }
    }
    return {
      success: false,
      error: response.data.error || 'Checkout failed, please try again.'
    }
  } catch (err: any) {
    return {
      success: false,
      error:
        err?.response?.data?.error ||
        err?.message ||
        'Checkout failed, please try again.'
    }
  }
}

export const checkOrderLockStatus =
  async (): Promise<OrderLockStatusResponse> => {
    try {
      const response = await axios.get('/orders/check-lock-status')

      if (response.status === 200) {
        const { locked, orderCompleted, message } = response.data

        if (locked) {
          return { locked: true }
        } else {
          return {
            locked: false,
            orderCompleted: orderCompleted,
            message: message
          }
        }
      }

      return {
        locked: false,
        orderCompleted: false,
        message: 'Unexpected response from server'
      }
    } catch (error: any) {
      return {
        locked: false,
        orderCompleted: false,
        message: error?.response?.data?.error || 'Failed to check order status'
      }
    }
  }
